module.exports = __webpack_public_path__ + "static/media/ilocalboxlogo.3d295445.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/ilocalboxlogo.png
// module id = 1583
// module chunks = 0